import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';

import { Sidebar, Topbar, Footer } from './components';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%'
    },
    shiftContent: {
        paddingLeft: 228 // matches new sidebar width
    },
    content: {
        height: '100%'
    }
}));

const Main = props => {
    const { children, userProfile, journalMarket } = props;

    const classes = useStyles();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
        defaultMatches: true
    });

    const [openSidebar, setOpenSidebar] = useState(false);

    const handleSidebarOpen = () => setOpenSidebar(true);
    const handleSidebarClose = () => setOpenSidebar(false);

    const shouldOpenSidebar = isDesktop ? true : openSidebar;

    return (
        <div
            className={clsx(classes.root, {
                [classes.shiftContent]: isDesktop
            })}>
            <Topbar onSidebarOpen={handleSidebarOpen} />

            <Sidebar
                onClose={handleSidebarClose}
                open={shouldOpenSidebar}
                roleId={userProfile.getRoleId()}
                journalId={journalMarket.getId()}
                variant={isDesktop ? 'persistent' : 'temporary'}
            />

            <main className={classes.content}>
                {children}
                <Footer />
            </main>
        </div>
    );
};

Main.propTypes = {
    children: PropTypes.node,
    userProfile: PropTypes.object.isRequired,
    journalMarket: PropTypes.object.isRequired
};

export default Main;
